import { HtmlEntityType } from '../enums/HtmlEntityType';

/**
 * Enquotes a text with `“` and `”`.
 */
export const enquote = (text: string): string =>
  `${HtmlEntityType.OpenQuotation}${text}${HtmlEntityType.CloseQuotation}`;
